import { render, staticRenderFns } from "./BannersView.vue?vue&type=template&id=0abab9d3&scoped=true&"
import script from "./BannersView.vue?vue&type=script&lang=js&"
export * from "./BannersView.vue?vue&type=script&lang=js&"
import style0 from "./BannersView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BannersView.vue?vue&type=style&index=1&id=0abab9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abab9d3",
  null
  
)

export default component.exports